import { render, staticRenderFns } from "./appNewWebsitePopup.vue?vue&type=template&id=800b81a8&scoped=true"
import script from "./appNewWebsitePopup.vue?vue&type=script&lang=js"
export * from "./appNewWebsitePopup.vue?vue&type=script&lang=js"
import style0 from "./appNewWebsitePopup.vue?vue&type=style&index=0&id=800b81a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800b81a8",
  null
  
)

export default component.exports